// utils/validation.js

// Global values

const maxlength = 50;

export const validateUserName = (userName) => {
  if (!userName) return "UserName is required"; // Checks if userName is empty or null.
  if (/\s/.test(userName)) return "UserName should not contain spaces"; // Checks for spaces.
  if (!/^[a-zA-Z0-9]+$/.test(userName)) return "UserName must be alphanumeric"; // Ensures only alphanumeric characters.
  return ""; // Returns no error if all validations pass.
};

export const validatePassword = (password) => {
  if (!password) return "Password is required";
  if (password.length < 8 || password.length > 16)
    return "Password must be between 8 and 16 characters";
  if (!/[a-z]/.test(password))
    return "Password must contain at least one lowercase letter";
  if (!/[A-Z]/.test(password))
    return "Password must contain at least one uppercase letter";
  if (!/[0-9]/.test(password))
    return "Password must contain at least one digit";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
    return "Password must contain at least one special character";
  return "";
};

export const validate = (fieldName, value) => {
  if (!value) return `${fieldName} is required`;
  // if (value.length > maxlength)
  //   return `${fieldName} length must be at least ${maxlength} characters`;
  // if (!/^[a-zA-Z0-9]+$/.test(fieldName))
  //   return `${fieldName} must be alphanumeric`;
};

export const validatePincode = (pincode) => {
  if (!pincode) return "Pincode is required";
  if (pincode.length !== 6) return "Pincode must be exactly 6 digits";
  if (!/^\d+$/.test(pincode)) return "Pincode must contain only numeric digits";
  return null; // No validation errors
};

export const validatePAN = (pan) => {
  if (!pan) return "PAN is required";

  if (!/^[A-Z]{5}\d{4}[A-Z]$/.test(pan))
    return "PAN must follow the format: 5 uppercase letters, 4 digits, and 1 uppercase letter";
  if (pan.length !== 10) return "PAN must be exactly 10 characters";
  return null; // No validation errors
};
export const validateMobileNumber = (mobileNumber) => {
  if (!mobileNumber) return "Mobile number is required";
  if (mobileNumber.length !== 10)
    return "Mobile number must be exactly 10 digits";
  if (!/^\d+$/.test(mobileNumber))
    return "Mobile number must contain only numeric digits";
  if (!/^([6-9]\d{9})$/.test(mobileNumber))
    return "Mobile number must start with a digit between 6 and 9";
  return null; // No validation errors
};
export const validateEmail = (email) => {
  if (!email) return "Email is required";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
  if (!emailRegex.test(email)) return "Please enter a valid email address";
  return null; // No validation errors
};

export const Is = [{ title: "Yes" }, { title: "No" }];

export const getDefaultDateRange = () => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  return {
    startDate: firstDayOfMonth,
    endDate: today,
    startDateStr: firstDayOfMonth.toISOString().split("T")[0],
    endDateStr: today.toISOString().split("T")[0],
  };
};

export const formatDateToDisplay = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "--";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
